export default {
  worldCup: {
    tab1:'赛程',
    tab2:'队伍',
    tab3:'下注记录',
    tab4:'房间',
    tab5:'模板',

    tempId:'模板ID',
    courseId:'赛程ID',
    userId:'用户ID',
    country:'国籍',
    roomId:'房间ID',
    room_user:'房主ID',
    ratio:'返点',
    ratioDetail:'返点详情',

    tableText1:'主队',
    tableText2:'客队',
    tableText3:'竞猜人数',
    tableText4:'下注金币数',
    tableText5:'回收金币数',
    tableText6:'赛果',
    tableText7:'中奖人数',
    tableText8:'当前返点',
    tableText9:'下注人数',
    tableText10:'已获取收益',
    tableText11:'下注时房间返点',
    tableText12:'房间收益',
    tableText13:'下注房间ID',
    tableText14:'下注对象',
    tableText15:'收益',
    tableText16:'下注时间',
    score:'比分',
    remark:'备注',

    teamId:'队伍ID',
    teamImg:'队伍图标',
    teamName:'队伍名称',
    result_status:'状态',

    activityName:'活动标题',
  }
}



// WEBPACK FOOTER //
// ./src/language/worldCup-zh-cn.js